import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { JSX } from 'react';
interface Props {
  children?: React.ReactNode;
  onItemClick?: () => unknown;
  testId?: string;
}
export function MenuContainer(props) {
  const $ = _c(7);
  const {
    onItemClick,
    children,
    testId
  } = props;
  let t0;
  if ($[0] !== onItemClick) {
    t0 = event => {
      if (event.key === "Enter") {
        onItemClick?.();
      }
    };
    $[0] = onItemClick;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== children || $[3] !== onItemClick || $[4] !== t0 || $[5] !== testId) {
    t1 = <div onClick={onItemClick} role="menu" tabIndex={0} onKeyDown={t0} data-testid={testId}>{children}</div>;
    $[2] = children;
    $[3] = onItemClick;
    $[4] = t0;
    $[5] = testId;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}